export default "__VITE_ASSET__DRbo3DrB__"